import React, {Component, PropTypes} from 'react'
import {connect} from 'react-redux'
import {getWillDocUrl} from './wil-duck'
import styles from './willdoc.scss'
import loadingUrl from '!!file-loader!./spinner.html'

@connect(
	({willdoc}) => ({
		url: willdoc || loadingUrl,
	}),
	{getWillDocUrl}
)
class WillDoc extends Component {
	static propTypes = {
		getWillDocUrl: PropTypes.func.isRequired,
		url: PropTypes.string,
	}
	constructor(props) {
		super(props)
		this.state = {loading: true}
	}
	componentDidMount() {
		this.props.getWillDocUrl()
		// Give the browser a chance to show the loading html
		this.t = setTimeout(
			() => {this.setState({loading: false})},
			300,
		)
	}
	componentWillUnmount() {
		clearTimeout(this.t)
	}
	render() {
		const {url} = this.props
		const {loading} = this.state
		return (
			<div className={styles.wdFrame}>
				<iframe src={loading ? loadingUrl : url}/>
			</div>
		)
	}
}

export default WillDoc



// WEBPACK FOOTER //
// ./components/willdoc/index.jsx